import { Location } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
// import { environment } from 'src/environments/environment.dev';

@Component({
  selector: 'app-resource',
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.css'],
})
export class ResourceComponent {

  videos: any = '';
  elementId: any = '1';
  toggle: any = '';
  selected: any = '';
  isVideoOpen: Boolean = false;
  isToggle: Boolean = false;
  router = inject(Router);
  _location = inject(Location);
  selectedItem: any = {};

  toggleShowDiv(id: string = '') {
    if (id)
      this.toggle = id;
    else
      this.toggle = '';
  }

  backBtn() {
    this.isVideoOpen = false;
    this.elementId = '1';
    this.selected = '';
    this.isToggle = false;
    this.toggle = '';
    this._location.go('/video-resources');
  }

  /*****************************************
   * new code 
   */

  public assetArray = [
    {
      id: '1',
      title: 'What is an IEC (Importer & Exporter Code)?',
      url: 'assets/pmbReelsFile/iecVideo.mp4',
      weburl: "/what-is-iec-importer-exporter-code",
      shareUrl: "",
      thumbnail: 'assets/pmbReelsFile/thumbnail_iec.png',
      alt: 'Apply for an IEC (Importer & Exporter Code) online through DGFT.',
      videoDescription: "Learn all about IEC (Importer & Exporter Code), including its full form and application process. Discover how IEC can help your business go global.",
      description: `
      <p>
      An IEC (Importer & Exporter Code) is the very first thing you need to do as a business to export and import, and take your product global.
      <br>
      <br>
      <h4>Understanding the IEC Full Form</h4>
      <br>
      The IEC full form is Importer & Exporter Code, a mandatory registration for businesses involved in international trade.
      <br>
      <br>
      <h4>How to Apply for an IEC</h4>
      <br>
      Getting an IEC is easy online; you just have to apply through DGFT (Directorate General of Foreign Trade) 
      using this link: <span>
      <a href="https://www.dgft.gov.in/CP/?opt=iec-profile-management" target="_blank"> DGFT (Directorate General of Foreign Trade).
      </a>
      </span>
      <br>
      <br>
      <h4>Who Can Apply for an IEC?</h4>
      <br>
      To apply, you need a PAN, a bank account in the firm's name, and a valid address. The DGFT may also physically verify your address upon issuance of the IEC.
      <br>

      The IECs now issued are the same as the firm's PAN. However, DGFT will still issue the IEC separately based on the application.
      The nature of the firm obtaining an IEC can be a Proprietorship, Partnership, LLP, Limited Company, Trust, HUF, or even a Society.
      <br>
      </p>
      `
    },
    {
      id: '2',
      title: "Understanding Courier Charges by Weight",
      url: 'assets/pmbReelsFile/weightChargesVideo.mp4',
      weburl: "/what-is-courier-chargeable-weight",
      thumbnail: 'assets/pmbReelsFile/thumbnail_weightCharges.png',
      alt: 'Explanation of courier charges by weight and dimensional weight calculation.',
      videoDescription: "Learn how courier charges by weight are determined, including the difference between actual weight and chargeable weight. Understand the importance of dimensional weight in shipping costs.",
      description: `<p>
      Courier charges by weight are crucial to shipping costs, impacting how much you pay to send packages.
      <br>
     
      <h4>What is a Courier's “Chargeable Weight”?</h4>
       
      Actual weight refers to the physical weight of the package, measured in kilograms using a scale. It is the real, 
      tangible weight of the package when placed on a scale, and it is the weight that you would typically measure with a weighing scale.
      <br>
      <br>
      <h4>Actual Weight vs. Chargeable Weight</h4>
     
      Chargeable weight, also known as dimensional weight or volumetric weight, takes into account not only the actual weight but also the size or volume of the package.
      It ensures that the shipping charges reflect the space the package occupies in the courier's transportation system.
      <br>
      <br>
     
      <h4>How Courier Weight Charges Are Calculated?</h4>
    
      The volumetric weights are calculated using a formula that multiples the dimensions (length x breadth x height) and then divides it by a factor of usually 4500 to 6000, depending on the service and courier.
      <br>
      The most common one is usually 5000. This ensures that if you have a lightweight item that still takes up a lot of space, you'll be charged a higher amount than a small item that weighs the same.
    
      <br>
      <br>
      <h4>Importance of Dimensional Weight in Shipping</h4>
     
      Understanding the concept of dimensional weight is essential for accurately predicting and managing shipping costs, ensuring fair pricing based on the space a package occupies in the courier's system.
      <br>
      </p>`
    },
    {
      id: '3', title: 'What is an Import Duty?',
      url: 'assets/pmbReelsFile/dutiesVideo.mp4',
      weburl: "/what-is-import-duty",
      thumbnail: 'assets/pmbReelsFile/thumbnail_duties.png',
      alt: "Import Duty Explanation.",
      videoDescription: "Learn about the factors affecting import duty rates, including trade agreements and HSN codes.",
      description: `
      <p>
     
      Import duty is a tax we pay to the government for importing a product into the country. The duty rates depend on three main factors:
      <br>
      <br>
      <h4>Country of Origin</h4>
       
      The country you are importing from plays a significant role in determining the import duty. Your government may have specific trade agreements with the exporting country.
      These agreements can result in lower or higher duty rates depending on whether the government wants to encourage or discourage imports from that country.
      <br>
      <br>
      <h4>Product Classification by HSN Code</h4>
    
      The type of product you are importing is classified by the HSN (Harmonized System of Nomenclature) code, a standard 6-digit code used globally to classify products.
      Import duty rates are determined based on the HSN code of the product.
      <br>
      <br>
      <h4>Purpose of Import - Personal vs. Commercial</h4>
     
      The purpose of the import, whether personal or commercial, also affects the duty rates. Personal imports include gifts or items for individual use and are imported under your name. Commercial imports are brought in under a company name with a business IEC/PAN. For personal imports, the IEC is a standard code used by the government for classification.
      In India, the duty rate on personal imports is a flat 35%, which also attracts GST.
      <br>
      </p>  
      `
    },
    {
      id: '4', title: 'What is an AD Code?',
      url: 'assets/pmbReelsFile/adCodeVideo.mp4',
      weburl: "/what-is-ad-code",
      thumbnail: 'assets/pmbReelsFile/thumbnail_AdCode.png',
      alt: 'Process of obtaining an AD Code from the Reserve Bank of India.',
      videoDescription: "Learn what an AD code or Authorized Dealer Code is, why it is essential for foreign exchange transactions, and how to obtain it for regulatory compliance in India.",
      description: `<p>
      An AD Code, or Authorized Dealer Code, is a unique identifier assigned to authorized dealers (banks) by the Reserve Bank of India (RBI).
      The AD Code is essential for conducting foreign exchange transactions, particularly for import and export activities.
      Each bank is given a specific AD Code, which must be used in all foreign exchange dealings by the associated entity.
      <br>
      <h4>Importance of AD Code (Authorized Dealer Code)</h4>
      <h5>Regulatory Compliance</h5>
     
      The AD Code is mandated by the Reserve Bank of India to ensure regulatory compliance in foreign exchange transactions.
      It helps enforce the regulations set forth by the RBI and other relevant authorities.
      <br>
      <br>
      <h5>Identification of Authorized Dealers</h5>
    
      The Authorized Dealer Code serves as a means to identify which bank is processing a foreign exchange transaction. This identification ensures transparency and accountability in the market.
      <br>
      <br>
      <h5>Tracking Transactions</h5>
      
      Regulatory bodies use the AD Code to track foreign exchange transactions effectively. By linking each transaction to a specific authorized dealer, authorities can monitor the flow of funds and identify any suspicious activities or regulatory violations.
      <br>
      <br>
      <h5>How to Obtain an AD Code</h5>
      
      Obtaining an AD Code is an online process facilitated by most banks. The process generally takes a few days to a week. After obtaining the code, you must submit it to the customs station where your clearances are processed.
      <br>
      <br>
      <h5>Conclusion</h5>
      
      The AD Code or Authorized Dealer Code is crucial for regulatory compliance, identification of authorized dealers, and tracking of foreign exchange transactions.
      Ensure you obtain your AD Code from your bank and submit it to the relevant customs station for smooth international trade operations.
      <br>
      </p>`
    },
    {
      id: '5',
      title: 'What is a HSN?',
      url: 'assets/pmbReelsFile/hsnCodeVideo.mp4',
      weburl: "/what-is-hsn-code",
      thumbnail: 'assets/pmbReelsFile/thumbnail_HSN.png',
      alt: "Chart displaying the structure and examples of HSN codes used in international trade.",
      videoDescription: "Discover what the Harmonized System of Nomenclature (HSN) is and how it facilitates international trade through uniform classification of goods. Learn why HSN codes are crucial for export.",
      description: `<p>
      The Harmonized System of Nomenclature (HSN) is a standardized system for classifying goods across the globe.
      The HSN facilitates international trade by ensuring a uniform classification of goods, making it easier for countries to conduct trade efficiently and systematically.
      <br>
      
      <h4>The Structure of HSN Codes</h4>
 
      <br>
      <h5>Understanding HSN Codes</h5>
    
      An HSN code is a 6-digit uniform code used to classify over 5000 commodity groups. Supported by well-defined rules, these codes achieve uniform classification accepted worldwide. In certain countries, 
      like India, the HSN code can extend to 8 digits. Each product is assigned a 6 to 8 digit HSN code, ensuring that products within the same category have identical duty rates within the same country.
      <br>
      <br>
     
      <h5>Importance in Exporting</h5>
      
      When exporting any product, it is crucial to include the HSN code on your export invoice. 
      This code determines the duty rate applicable to your product. The Harmonized System of Nomenclature is utilized by more than 200 countries and economies for:
      <br>
      
      <ul>
        <li>Uniform classification of goods</li>
        <li>Establishing Customs tariffs</li>
        <li>Collecting international trade statistics</li>
        <li>Why Use the Harmonized System of Nomenclature?</li>
        <li>Uniform Classification</li>
      </ul>
      
      <br>
      The Harmonized System of Nomenclature provides a consistent method for classifying goods.
      This uniformity simplifies international trade, reduces misunderstandings, and helps maintain consistency in trade documentation.
      <br>
      <br>
      
      <h5>Customs Tariffs</h5>
      
      The HSN serves as a base for setting Customs tariffs. By using the HSN code, countries can determine the appropriate duty rates for different goods, ensuring fair trade practices.
       
      <br>
      <br>
      <h5>Trade Statistics</h5>
       
      The collection of international trade statistics relies on the HSN system. Accurate data collection helps in analyzing global trade patterns and making informed policy decisions.
      <br>
      <br>
       
      <h5>Tools for Finding HSN Codes</h5>
      
      For businesses, finding the right HSN code can be challenging. 
      PikMyBox offers a tool for registered customers to determine the most suitable and accurate HSN code for their products, simplifying the export process.
  
      <br>
      <br>
      <h5>Over to you</h5>
       
      The Harmonized System of Nomenclature (HSN) is essential for the systematic classification of goods in international trade. 
      Understanding what an HSN is and how to use it can significantly streamline export procedures and ensure compliance with global trade regulations.
      <br>

      </p>`
    },
    {
      id: '6', title: 'What are exchange rates?',
      url: 'assets/pmbReelsFile/exchangeRateVideo.mp4',
      weburl: "/what-is-exchange-rate",
      thumbnail: 'assets/pmbReelsFile/thumbnail_exchangeRates.png',
      alt: "Graph showing fluctuations in exchange rates over time.",
      videoDescription: "Learn what exchange rates are, how they are determined, and their impact on international trade and the economy. Find out how to stay compliant with updated exchange rates using PikMyBox.",
      description: `
      <p>
      When you are exporting a product, you need to fill out your customs declaration and provide both the foreign currency and Indian currency value of the product you are sending.
      Understanding what exchange rates are is crucial in this process.
       
      <br>
      <br>
      <h4>Determining Exchange Rates</h4>
      
      You cannot rely on Google for accurate exchange rates. Instead, the customs department notifies 22 different exchange rates and foreign currencies that you need to use. 
      These rates are updated every two weeks on their portal and automatically on the PikMyBox application to ensure your documents are always compliant.
      
      <br>
      <br>
      <h4>Factors Influencing Exchange Rates</h4>
      
      <ul>
        <li>Supply and demand for currencies</li>
        <li>Interest rates</li>
        <li>Inflation rates</li>
        <li>Economic performance</li>
        <li>Geopolitical events</li>
        <li>Government policies</li>
      </ul>
    
      <br>
      In India, the Reserve Bank of India (RBI) plays a significant role in regulating exchange rates through interventions in the foreign exchange market, monetary policies, and other measures to maintain stability and support the country's economic objectives.
      
      <br>
      <br>
      <h4>Impact of Exchange Rates</h4>
     
      Exchange rates impact various aspects of the economy, including international trade, foreign investments, and inflation. For instance:
      <br>
     
      <ul>
        <li>A weaker rupee relative to other currencies may boost exports but could lead to higher import costs and inflation.</li>
        <li>A stronger rupee may benefit consumers by reducing import costs but could harm export competitiveness.</li>
      </ul>
      
      <br>
      <br>
      <h4>Staying Updated with Exchange Rates</h4>
    
      PikMyBox is linked with the Indian exchange rate system and automatically updates the latest exchange rates on the application. 
      This ensures you always use the correct rates for your international trade documents, maintaining compliance and accuracy.
      <br>
      <br>
     
      <h4>Wrapping Up</h4>
      
      Understanding what exchange rates are and how they are determined is essential for anyone involved in international trade. 
      Exchange rates influence economic performance, trade dynamics, and inflation. By staying updated with accurate and compliant exchange rates through reliable platforms like PikMyBox, 
      you can ensure smooth and efficient international transactions.
      <br>
      </p>
      `
    },
    {
      id: '7',
      title: 'What is an eBRC?',
      url: '',
      weburl: "/what-is-ebrc",
      thumbnail: '',
      alt: " eBRC issuance process from banks to exporters.",
      videoDescription: "Learn what eBRC is, the process to obtain it, and its importance in proving foreign payments for exported goods. Ensure compliance with electronic bank realization certificates.",
      description: `
      <p>
      An eBRC, or electronic bank realization certificate, is issued by banks to prove that the foreign payment received corresponds to the products exported. 
      Understanding what is eBRC is crucial for exporters to ensure compliance and claim IGST refunds.
      <br>
 
      <h4>Process to Obtain an eBRC</h4>
    
      <br>
      <h5>Submitting Documents to the Bank</h5>
    
      To obtain an eBRC, exporters must submit proof of delivery and the export bill (courier shipping bill - IV or V, or postal bill of export/PBE) to their bank. 
      If exporting through India Post, the PBE must be signed and stamped by customs.
      <br>
      <br>
      
      <h5>Bank Verification</h5>
    
      The bank vets the submitted documents to confirm that the parcels have been delivered. 
      After verification, the bank issues the eBRC. This process can be completed through the banking portal, email, or by visiting the bank branch with physical documents.
      
      <br>
      <br>
      <h4>Submission to DGFT and ICEGATE</h4>
 
     
      <h5>Bank Submission to DGFT</h5>
    
      Once the eBRC is issued, the bank submits the document to the Directorate General of Foreign Trade (DGFT). Exporters can then download their BRC from the DGFT website.
      
      <br>
      <br>
      <h5>Submission to ICEGATE</h5>
      
      The final step involves submitting the eBRC to ICEGATE (the government's exim portal) to claim IGST refunds of 18% on exported goods.
      
      <br>
      <br>
      <h5>Conclusion</h5>
     
      Understanding what is eBRC and its importance is essential for exporters to prove foreign payments and claim IGST refunds. 
      By following the correct procedures to obtain an eBRC, exporters can ensure compliance and smooth processing of their export-related financial transactions
      <br>
      </p>
      `
    },
  ];

  openVideo(id, url?) {
    // // console.log("openVideo >> id, url >> ", id, url);
    if (url) {
      this._location.go('/video-resources' + url);
      // this.router.createUrlTree([]
    }
    this.isVideoOpen = true;
    this.selected = id;
    this.isToggle = false;
    document.getElementById('vCont').scrollLeft += 100;
  }


  /**************************************** */

  scrollFunction(type, dd = '') {
    // // console.log(type, dd);
    if (type == 'eq') {
      let element = document.getElementById(dd);
      element.scrollIntoView();
      this.elementId = dd;
    }

    let id: any = '';
    if (type == 'plus') {
      if (this.selected == this.elementId) {
        id = Number(this.elementId) + 2;
      } else {
        id = Number(this.elementId) + 1;
      }
    } else {
      if (this.selected == this.elementId) {
        id = Number(this.elementId) - 2;
      } else {
        id = Number(this.elementId) - 1;
      }
    }

    if (id > this.assetArray.length || id < 1) {
      // console.log("scrollFunction invalid id >> ", id);
      if (type == 'plus') {
        document.getElementById('vCont').scrollLeft += 400;
      } else {
        document.getElementById('vCont').scrollLeft -= 400;
      }
    } else {
      try {
        if (id) {
          let element = document.getElementById(id);

          if (element) {
            element.scrollIntoView();

            if (type == 'plus') {
              document.getElementById('vCont').scrollLeft += 200;
            }
            this.elementId = id;
          } else {
            if (type == 'plus') {
              document.getElementById('vCont').scrollLeft += 200;
            } else {
              document.getElementById('vCont').scrollLeft -= 200;
            }
          }
        }
      } catch (ee) {
        // console.log("scrollFunction catch >> ", ee);
      }
    }
  }

  toggleDownUp() {
    // // console.log("before >> ", this.isToggle);
    this.isToggle = !this.isToggle;
    // // console.log("after >> ", this.isToggle);
  }

  copyInputMessage(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }

  /****
   * mobile view vars
   */

  selectedDescriptionId: any = '';
  selectedvideoid: any = '';
  isMobileVideoOpen: boolean = false
  videoDescOpen: boolean = false

  showSelectedDesc(id: string = '') {
    if (id)
      this.selectedDescriptionId = id;
    else
      this.selectedDescriptionId = '';

    this.isMobileVideoOpen = false;
    this.selectedvideoid = '';
  }


  openMobileVideo(id, url?) {
    if (id) {
      this.isMobileVideoOpen = true;
      this.selectedvideoid = id;
      if (url) {
        this._location.go('/video-resources' + url);
      }
    } else {
      this.isMobileVideoOpen = false;
      this.selectedvideoid = '';
    }
  }

  share(data) {
    this.selectedItem = data;
  }
}





